export default __webpack_public_path__ + "static/media/145.18a4293c.png";